<h4 class="chartTitle" *ngIf="chartTitle()">
  {{ chartTitle() }}
</h4>
<div class="lineChartDiv" [id]="chartdiv_id"></div>
